export default "__VITE_ASSET__CuZlUi1X__"